import React from "react";
 
const ContactBook = ({
  onClickFn = () => {},
  width = "22",
  height = "22",
  fill = "currentColor",
}) => {
  return (
<svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
>
    <path d="M4.5 0C2.84531 0 1.5 1.34531 1.5 3V21C1.5 22.6547 2.84531 24 4.5 24H18C19.6547 24 21 22.6547 21 21V3C21 1.34531 19.6547 0 18 0H4.5ZM9.75 13.5H12.75C14.8219 13.5 16.5 15.1781 16.5 17.25C16.5 17.6625 16.1625 18 15.75 18H6.75C6.3375 18 6 17.6625 6 17.25C6 15.1781 7.67812 13.5 9.75 13.5ZM8.25 9C8.25 8.20435 8.56607 7.44129 9.12868 6.87868C9.69129 6.31607 10.4544 6 11.25 6C12.0456 6 12.8087 6.31607 13.3713 6.87868C13.9339 7.44129 14.25 8.20435 14.25 9C14.25 9.79565 13.9339 10.5587 13.3713 11.1213C12.8087 11.6839 12.0456 12 11.25 12C10.4544 12 9.69129 11.6839 9.12868 11.1213C8.56607 10.5587 8.25 9.79565 8.25 9ZM24 3.75C24 3.3375 23.6625 3 23.25 3C22.8375 3 22.5 3.3375 22.5 3.75V6.75C22.5 7.1625 22.8375 7.5 23.25 7.5C23.6625 7.5 24 7.1625 24 6.75V3.75ZM23.25 9C22.8375 9 22.5 9.3375 22.5 9.75V12.75C22.5 13.1625 22.8375 13.5 23.25 13.5C23.6625 13.5 24 13.1625 24 12.75V9.75C24 9.3375 23.6625 9 23.25 9ZM24 15.75C24 15.3375 23.6625 15 23.25 15C22.8375 15 22.5 15.3375 22.5 15.75V18.75C22.5 19.1625 22.8375 19.5 23.25 19.5C23.6625 19.5 24 19.1625 24 18.75V15.75Z" fill="white"/>
</svg>
  );
};
 
export default ContactBook;